import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboTipoAlimentacionActiva`, method: 'GET', body: null, token: token})
}
